import { Provider } from '@angular/core';
import {
  ZOP_BRANDING_CONFIG,
  ZopBrandingConfig,
} from '../services/branding/branding-config';

/**
 * Provides branding configuration for the application
 *
 * @param config - Branding configuration object
 * @returns Provider for branding configuration
 *
 * @example
 * ```typescript
 * // In app.config.ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideZopBranding({
 *       appName: 'Zopup',
 *       logoLightUrl: 'assets/images/logo/zopup-light.svg',
 *       logoDarkUrl: 'assets/images/logo/zopup-dark.svg',
 *       logoAlt: 'Zopup Logo',
 *       images: {
 *         authHero: 'assets/images/auth/hero.svg'
 *       },
 *       animations: {
 *         authHero: 'assets/animations/zopup-dark.json'
 *       }
 *     }),
 *     // ... other providers
 *   ]
 * };
 * ```
 */
export const provideZopBranding = (config: ZopBrandingConfig): Provider => {
  return {
    provide: ZOP_BRANDING_CONFIG,
    useValue: config,
  };
};
